import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { NewsReducer } from './GreatIt.Cms/Blocks/NewsBlock/NewsBlock.reducer';
import { VideoBlockReducer } from './GreatIt.Cms/Blocks/VideoBlock/VideoBlock.reducer';
import { browserSize } from './Reducers/BrowserSize.reducer';
import { LogotypeReducer } from './GreatIt.Cms/Blocks/LogotypeBlock/LogotypeBlock.reducer';
import { newsOverView } from './Reducers/NewsOverview.reducer';
import { HistoryReducer } from './GreatIt.Cms/Blocks/HistoryBlock/HistoryBlock.reducer';
import { InvestmentReducer } from './GreatIt.Cms/Pages/InvestmentPage/InvestmentPage.reducer';
import { VideoReducer } from '../Scripts/GreatIt.Cms/Pages/VideoPage/VideoPage.reducer';
import { TimeLineReducer } from './GreatIt.Cms/Blocks/TimeLineBlock/TimeLineBlock.reducer';
import { FMGFormReducer } from './GreatIt.Cms/Blocks/FMGFormBlock/FMGFormBlock.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    NewsReducer,
    VideoBlockReducer,
    browserSize,
    LogotypeReducer,
    HistoryReducer,
    newsOverView,
    InvestmentReducer,
    VideoReducer,
    TimeLineReducer,
    FMGFormReducer
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
